import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useLocation } from "react-router-dom";
import { useAuth } from "src/app/utils/useAuth";
import { PageTitle, usePageData } from "src/_metronic/layout/core";
import { SimpleEntityGrid } from "../../../components/grid/SimpleEntityGrid";
import {
    UpsertOrderFormBodyModalContainer,
    UpsertOrderFormContainer,
    UpsertRDOrderModalContainer,
    ViewTextToCopyContainer,
} from "../../../containers";
import { OrderTransport } from "../../../transports/order";
import { UpsertOrderDTOSchema } from "../../../types/orders/order";
import useProcessGridActions from "./useProcessGridActions";
import useProcessGridColumns from "./useProcessGridColumns";

const ProcessGrid: React.FC = () => {
    const { formatMessage } = useIntl();
    const { setPageToolbarLinks } = usePageData();
    const { currentUser } = useAuth();
    const location = useLocation();

    const actions = useProcessGridActions(currentUser);
    const gridColumns = useProcessGridColumns();

    useEffect(() => {
        setPageToolbarLinks([]);
    }, [location]);

    return (
        <>
            <PageTitle>{formatMessage({ id: "process.title" })}</PageTitle>
            <SimpleEntityGrid
                //GRID
                columns={gridColumns}
                listHandler={OrderTransport.listToProcess}
                //ACTIONS
                toggleActiveHandler={OrderTransport.toggleActive}
                actions={actions}
                viewTextFormBodyContainer={ViewTextToCopyContainer}
                chooseRDFormBodyContainer={UpsertRDOrderModalContainer}
                UpsertFormBodyContainer={UpsertOrderFormBodyModalContainer}
                //TOOLBAR
                toolbarButtonAction={{ export: true, active: true, metrics: false, add: false }}
                //EDIT
                entityName={formatMessage({ id: "common.entity.process" })}
                modalProps={{ size: "xl" }}
                formTransformer={OrderTransport.formTransformer}
                formBody={UpsertOrderFormContainer}
                validationSchema={UpsertOrderDTOSchema}
                saveHandler={OrderTransport.save}
            />
        </>
    );
};
export default ProcessGrid;
